const resource = '/admin/v1/types';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  },

  getMetaList() {
    return $axios.get(`${resource}/metas`);
  },

  getTypesByCategoryId(categoryId) {
    return $axios.get(`${resource}/get-by-category/${categoryId}`);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  }
});
